const files = {
  description: 'arquivo com o treinamento',
  trainmentWeb: 'Playlist com o treinamento para a web',
  trainmentApp: 'Playlist com o treinamento para o app',
};

export default files;
